import React from "react";
import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import PropTypes from "prop-types";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";

import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContentText from "@mui/material/DialogContentText";
import { useColorTheme } from "../../../context/ColorThemeContext";

function Reset2FA({ open, onClose, onReset }) {
  const colors = useColorTheme();
  return (
    <Dialog
      sx={{
        "& .MuiDialog-paper": {
          width: "30% !important", // Đặt độ rộng là 40%
          maxWidth: "none", // Bỏ giới hạn mặc định
        },
      }}
      open={open}
      onClose={onClose}
    >
      <DialogTitle
        sx={{
          backgroundColor: colors.popupBackground || "var(--blue-blue-100)",
          color: colors.popupText || "white !important",
          padding: "13px 20px",
          fontWeight: "bold",
          fontSize: "18px",
          position: "relative",
          display: "flex",
          justifyContent: "center",
        }}
      >
        Xác nhận
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "white !important",
        }}
      >
        <CloseIcon />
      </IconButton>{" "}
      <DialogContent sx={{ paddingTop: "0px !important" }}>
        <DialogContentText id="alert-dialog-description">
          <SuiTypography
            mt={2}
            textAlign="center"
            whiteSpace="normal" // Cho phép xuống dòng
            fontSize="15px"
            style={{
              textTransform: "none",
              wordBreak: "break-word", // Tự động xuống dòng khi gặp từ dài
            }}
          >
            Bạn có chắc chắn muốn đặt lại xác thực 2 bước của người dùng không?
          </SuiTypography>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          paddingTop: "0px !important",
          mb: 1,
          justifyContent: "center", // Căn giữa theo chiều ngang
          display: "flex",
        }}
      >
        <SuiButton
          color="transparent"
          sx={{
            border: "1px solid var(--blue-blue-100)",
            borderColor: colors.popupBackground || "var(--blue-blue-100) !important",
            width: "150px",
          }}
          onClick={onClose}
        >
          <SuiTypography
            align="center"
            whiteSpace="nowrap"
            variant="body2"
            color={colors.popupBackground || "var(--blue-blue-100)"}
            fontSize="14px"
          >
            Hủy
          </SuiTypography>
        </SuiButton>
        <SuiButton
          style={{ width: "150px" }}
          color={colors.popupBackground || "var(--blue-blue-100)"}
          onClick={onReset}
        >
          <Typography
            style={{ margin: "0 auto", display: "flex" }}
            align="center"
            whiteSpace="nowrap"
            variant="body2"
            color={colors.popupText || "white"}
            fontSize="14px"
          >
            Đặt lại
          </Typography>
        </SuiButton>
      </DialogActions>
    </Dialog>
  );
}
Reset2FA.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default Reset2FA;
